import {
  Box,
  Button,
  Container,
  TextField,
  Typography
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import HttpClient from "../api/HttpClient";
import ModalContainer from "../component/ModalContainer";
import NavBar from "../component/NavBar";
import { useLoading } from "../constant/LoadingContext";
import { SnackbarContext } from "../constant/SnackbarProvider";
import { useGlobalData } from "../constant/GlobalDataContext";
const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: "#F5F5F5",
    padding: theme.spacing(3),
    minHeight: "100vh",
    [`@media (max-width: 600px)`]: {
      padding: "24px 0",
    },
  },
  searchContainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(4),
    backgroundColor: "#FFFFFF",
    borderRadius: "32px",
    padding: "220px 80px",
    boxShadow: "0px 0px 15px 0px #0000001A",
    margin: "40px auto 0",
    height: "70vh",
    maxWidth: "785px",
  },
  searchTitle: {
    fontSize: "24px",
    color: "#454C96",
    fontWeight: 500,
    marginBottom: "10px",
    paddingLeft: "40px",
  },
  searchInputContainer: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    width: "100%",
    marginBottom: "60px",
  },
  searchInput: {
    flex: 1,
    "& .MuiOutlinedInput-root": {
      borderRadius: "100px",
      "& .MuiOutlinedInput-input": {
        padding: "15.5px 40px",
        color: "#84909F",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#CED2D6",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#CED2D6",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#454C96",
      },
    },
  },
  searchButton: {
    width: "120px",
    height: "48px",
    backgroundColor: "#908DF2",
    color: "#FFFFFF",
    borderRadius: "12px",
    fontSize: "20px",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "#7472D2",
    },
  },
  addSection: {
    marginTop: "20px",
  },
  addTitle: {
    fontSize: "24px",
    color: "#454C96",
    fontWeight: 500,
    marginBottom: "10px",
    paddingLeft: "40px",
  },
  addButton: {
    width: "100%",
    maxWidth: "350px",
    height: "48px",
    backgroundColor: "#454C96",
    color: "#FFFFFF",
    borderRadius: "12px",
    fontSize: "20px",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "#353982",
    },
  },
  buttonIcon: {
    marginRight: theme.spacing(1),
  },
}));

const MainPagePad: React.FC = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { setGlobalData } = useGlobalData();
  const { setLoading } = useLoading();
  const [searchValue, setSearchValue] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState("addNewForm");
  const [modalStaffInfo, setModalStaffInfo] = useState(null);
  const Snackbar = React.useContext(SnackbarContext);
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const handleSearch = async () => {
    if (!searchValue) {
      Snackbar.open({
        alertProps: { severity: "error" },
        message: "請輸入搜尋內容",
      });
      return;
    }

    setLoading(true);
    try {
      const response = await HttpClient().HandleIpadSearchStaffApi(
        { searchValue, userDataFilter: user?.data?.userDataFilter },
        (data) => {
          if (data?.staffData?.isAllOtherDocumentsSigned && data?.staffData?.isPersonalFormSigned) {
            setModalType("hrConfirmed");
            setOpenModal(true);
          } else if (!data?.staffData?.isPersonalFormSigned && !data?.staffData?.isAllOtherDocumentsSigned) {
            setModalStaffInfo(data?.staffData);
            setModalType("updateForm");
            setOpenModal(true);
            
          } else if(data?.staffData?.isPersonalFormSigned && !data?.staffData?.isAllOtherDocumentsSigned) {
            navigate("/p/main/documentLists", {
              state: {
                searchValue: data.staffData.id,
              },
            });
            setGlobalData({
              searchValue: data.staffData.id,
            });
          } else {
            Snackbar.open({
              alertProps: { severity: "error" },
              message: "搜尋失敗: 請檢查資料是否正確",
            });
          }
          setLoading(false);
        },
        (error) => {
          setLoading(false);
          Snackbar.open({
            alertProps: { severity: "error" },
            message: "搜尋失敗: " + error,
          });
        }
      );
    } catch (error) {
      setLoading(false);
      Snackbar.open({
        alertProps: { severity: "error" },
        message: "搜尋失敗: " + error,
      });
    }
  };

  const handleAddClick = () => {
    setModalType("addNewForm");
    setOpenModal(true);
  };

  return (
    <>
      <NavBar isBack={false} step={1} />
      <Box className={classes.container}>
        <Container>
          <Box className={classes.searchContainer}>
            <Typography className={classes.searchTitle}>
              搜尋員工個人資料表格
            </Typography>
            <Box className={classes.searchInputContainer}>
              <TextField
                className={classes.searchInput}
                variant="outlined"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                placeholder="輸入身份證號碼、手機號碼"
              />
              <Button
                className={classes.searchButton}
                variant="contained"
                onClick={handleSearch}
                startIcon={<SearchIcon className={classes.buttonIcon} />}
              >
                搜索
              </Button>
            </Box>
            <Box className={classes.addSection}>
              <Typography className={classes.addTitle}>
                新增個人資料表格
              </Typography>
              <Button
                className={classes.addButton}
                variant="contained"
                onClick={handleAddClick}
                startIcon={<AddIcon className={classes.buttonIcon} />}
              >
                新增表格
              </Button>
            </Box>
          </Box>
        </Container>
      </Box>
      <ModalContainer
        open={openModal}
        setOpen={setOpenModal}
        type={modalType}
        staffInfo={modalStaffInfo}
      />
    </>
  );
};

export default MainPagePad;
